module.exports = __webpack_public_path__ + "img/house-with-garden.be4883d9.png";